<template>
    <div>
        <notification-modal :firstAction="firstAction" :firstActionText="firstActionText" :messageTitle="messageTitle" :message="message" :notificationType="notificationType" :resetVariable="resetVariable"></notification-modal>
    </div>
</template>

<script>
export default {
    data () {
        return {
            messageTitle: 'Empty required fields',
            message: 'Please fill out all required fields.' ,
            notificationType: 'error',
            firstAction: 'close',
            firstActionText: '&nbsp;&nbsp;&nbsp;OK&nbsp;&nbsp;&nbsp;',
            resetVariable: 'showRequiredFieldMessage'
        }
    },
}
</script>